
function createWrapperAndAppendToBody(wrapperId) {
    const wrapperElement = document.createElement('div');
    wrapperElement.setAttribute("id", wrapperId);
    document.body.appendChild(wrapperElement);
    return wrapperElement;
}

function ElWrapper({children, refDOM, refBtn}){
    if(!children){
        return null;
    }
    let values = refDOM.current.getBoundingClientRect();
    let paddingBox = 42;
    const styleDiv = {
        'position': 'absolute',
        'left': `${values.x}px`,
        'top': `${values.y + window.scrollY + paddingBox}px`,
        // 'width': '100%'
    }
    return <div style={styleDiv}>
        {children}
    </div>
}

function PortalManager({ children, wrapperId = "react-portal-wrapper", refDOM, refBtn }) {
    const [wrapperElement, setWrapperElement] = React.useState(null);
    React.useLayoutEffect(() => {
        let element = document.getElementById(wrapperId);
        let systemCreated = false;
        // if element is not found with wrapperId or wrapperId is not provided,
        // create and append to body
        if (!element) {
            systemCreated = true;
            element = createWrapperAndAppendToBody(wrapperId);
        }
        setWrapperElement(element);

        return () => {
            // delete the programatically created element
            if (systemCreated && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }, [wrapperId]);

    // wrapperElement state will be null on very first render.
    if (wrapperElement === null) return null;
    return ReactDOM.createPortal(<ElWrapper refDOM={refDOM} refBtn={refBtn}>{children}</ElWrapper>, wrapperElement);
}

export default PortalManager;
